module.exports = __webpack_public_path__ + "img/borderBg-6aaa19.png";